import config from 'constants/apiConfig';
import parseErrorMessage from 'utils/parseErrorMessage';
import {
  GET_ROSTER_FOR_INCIDENT_REQUEST,
  GET_ROSTER_FOR_INCIDENT_SUCCESS,
  GET_ROSTER_FOR_INCIDENT_ERROR,
  ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_SELF_FROM_INCIDENT_REQUEST,
  REMOVE_SELF_FROM_INCIDENT_SUCCESS,
  REMOVE_SELF_FROM_INCIDENT_ERROR,
  GET_INCIDENT_LOGS,
  UPDATE_INCIDENT_LOGS_WITH_WORKLOG,
} from 'constants/incident-action-types';
import axios from 'axios';
import { saveAs } from 'file-saver';

import Blob from 'blob';
import { Parser } from '@json2csv/plainjs';
import { fetchIncidents } from './profileActions';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function getRosterForIncidentRequest() {
  return {
    type: GET_ROSTER_FOR_INCIDENT_REQUEST,
  };
}

function getRosterForIncidentSuccess(rosterData) {
  return {
    type: GET_ROSTER_FOR_INCIDENT_SUCCESS,
    payload: rosterData,
  };
}

function getRosterForIncidentError(error) {
  // TODO CRITICAL
  const errorMessage =
    'getRosterForIncidentError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: GET_ROSTER_FOR_INCIDENT_ERROR,
  };
}

export function getRosterForIncident() {
  return (dispatch, useState) => {
    const {
      app: { currentIncident },
    } = useState();
    const { id: incidentId } = currentIncident || {};
    dispatch(getRosterForIncidentRequest());
    if (incidentId) {
      return axios(config.apiGateway.getRosterForIncident, {
        method: 'POST',
        data: JSON.stringify({
          incident_id: incidentId,
        }),
      })
        .then((response) => {
          const rolesData = response.data || [];
          dispatch(getRosterForIncidentSuccess(rolesData));

          return rolesData;
        })
        .catch((error) => {
          dispatch(getRosterForIncidentError(error));
        });
    } else {
      dispatch(getRosterForIncidentSuccess([]));
    }
  };
}

function removeUserFromIncidentByAdminRequest() {
  return {
    type: REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST,
  };
}

function removeUserFromIncidentBySuccess(removedIncidentMember) {
  return {
    type: REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS,
    payload: removedIncidentMember,
  };
}

function removeUserFromIncidentByAdminError(error) {
  const errorMessage =
    'removeUserFromIncidentByAdminError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR,
  };
}

export function removeUserFromIncidentByAdmin(user) {
  return (dispatch, useState) => {
    const {
      app: { currentIncident },
    } = useState();
    const { id: incidentId } = currentIncident || {};
    const { group_guid } = useState().app.currentlySelectedGroup;
    dispatch(removeUserFromIncidentByAdminRequest());
    return axios(config.apiGateway.removeUserFromIncidentByAdmin, {
      method: 'POST',
      data: JSON.stringify({
        incident_id: incidentId,
        user_guid: user.user_guid,
        group_guid,
      }),
    })
      .then((response) => {
        const removedIncidentMember = response.data || [];
        dispatch(removeUserFromIncidentBySuccess(removedIncidentMember));
        dispatch(getRosterForIncident());
        return removedIncidentMember;
      })
      .catch((error) => {
        dispatch(removeUserFromIncidentByAdminError(error));
      });
  };
}

function removeSelfFromIncidentRequest() {
  return {
    type: REMOVE_SELF_FROM_INCIDENT_REQUEST,
  };
}

function removeSelfFromIncidentSuccess(removedSelfIncidentMember) {
  return {
    type: REMOVE_SELF_FROM_INCIDENT_SUCCESS,
    payload: removedSelfIncidentMember,
  };
}

function removeSelfFromIncidentError(error) {
  const errorMessage =
    'removeSelfFromIncidentError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: REMOVE_SELF_FROM_INCIDENT_ERROR,
  };
}

export function removeSelfFromIncident(user) {
  return (dispatch, useState) => {
    const {
      app: { currentIncident },
    } = useState();
    const { id: incidentId } = currentIncident || {};
    dispatch(removeSelfFromIncidentRequest());
    return axios(config.apiGateway.removeSelfFromIncident, {
      method: 'POST',
      data: JSON.stringify({
        incident_id: incidentId,
        user_guid: user.user_guid,
      }),
    })
      .then((response) => {
        const removedSelfIncidentMember = response.data || [];
        dispatch(removeSelfFromIncidentSuccess(removedSelfIncidentMember));
        dispatch(fetchIncidents());
        return removedSelfIncidentMember;
      })
      .catch((error) => {
        dispatch(removeSelfFromIncidentError(error));
      });
  };
}

export const getAllIncidentLogs = (incident_id) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.getIncidentLogs, {
      method: 'POST',
      data: JSON.stringify({
        incident_id: incident_id,
        group_guid: getState().app.currentlySelectedGroup.group_guid,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_INCIDENT_LOGS, payload: response.data });
      })
      .catch(() => {
        dispatch(
          incidentUserError('getIncidentLogs', {
            message: 'There was a problem with getting the incident logs',
          })
        );
      });
  };
};

export const getUserIncidentWorkLogTimes = (log_row) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.incidentMemberWorkLogs, {
      method: 'POST',
      data: JSON.stringify({
        incident_id: log_row.incident_id,
        user_guid: log_row.user_guid,
        group_guid: getState().app.currentlySelectedGroup.group_guid,
      }),
    })
      .then((response) => {
        if (response.data.length > 0) {
          dispatch({
            type: UPDATE_INCIDENT_LOGS_WITH_WORKLOG,
            payload: { logs: response.data, id: log_row.incident_member_id },
          });
        }
      })
      .catch(() => {
        dispatch(
          incidentUserError(
            'markIncidentMemberdeactive',
            'There was a problem with de-activating incident member'
          )
        );
      });
  };
};

export const downloadIncidentLogs = () => {
  return (dispatch, getState) => {
    const incidentMembersLogs = [
      ...getState().app.incidentLogs.incidentMembersLogs.map((e) => {
        return {
          'email_address/name': e.email_address,
          hours_worked: e.minutes_worked_in_words,
          incident_seat: e.incident_seat,
          location: '',
          notes: '',
        };
      }),
    ];
    const incidentNonMembersLogs = [
      ...getState().app.incidentLogs.incidentNonMembersLogs.map((e) => {
        return {
          'email_address/name': e.email_address,
          hours_worked: e.minutes_worked_in_words,
          incident_seat: e.incident_seat,
          location: e.location,
          notes: e.notes,
        };
      }),
    ];
    const IncidentLogs = [...incidentMembersLogs, ...incidentNonMembersLogs];
    let downloadDataBlob;
    if (IncidentLogs.length) {
      const fields = Object.keys(IncidentLogs[0]);
      const opts = { fields };
      const parser = new Parser(opts);
      const csv = parser.parse(IncidentLogs);
      downloadDataBlob = new Blob([csv], {
        type: 'application/csv',
      });
      saveAs(
        downloadDataBlob,
        'DICE ' + getState().app.currentIncident.name + ' logs.csv'
      );
    } else {
      toast.error('There are no records in this log.');
    }
  };
};

function incidentUserError(errorApi, error) {
  const errorMessage =
    errorApi +
    '\n\n' +
    parseErrorMessage(error) +
    '\n\n If you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
  };
}